document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.getElementById('MenuToggle');
  var nav = document.getElementById('MobileNav');

  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      nav.classList.toggle('is-open', !open);
      document.body.classList.toggle('nav-open', !open);
    });
  }

  // Gallery: photos/videos pop in one by one in random order, then settle into the grid.
  // There can be more than one gallery section on a page, so handle all of them.
  var galleryGrids = Array.prototype.slice.call(document.querySelectorAll('.gallery__grid'));
  galleryGrids.forEach(function (galleryGrid) {
    var items = Array.prototype.slice.call(galleryGrid.querySelectorAll('.gallery__item'));
    var revealed = false;

    var reveal = function () {
      if (revealed || !items.length) return;
      revealed = true;

      var order = items.slice();
      for (var i = order.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = order[i];
        order[i] = order[j];
        order[j] = tmp;
      }

      order.forEach(function (item, index) {
        var delay = index * 160 + Math.random() * 220;
        setTimeout(function () {
          item.classList.add('is-visible');
        }, delay);
      });
    };

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            reveal();
            observer.disconnect();
          }
        });
      }, { threshold: 0.15 });
      observer.observe(galleryGrid);
    } else {
      reveal();
    }
  });
});
